import React, {
  MouseEventHandler,
  ReactNode,
  PropsWithChildren,
} from 'react';
import clsx from 'clsx';
import ToolTip from 'core/components/Tooltip';
import MuiIconButton from '@mui/material/IconButton';
import Badge, {
  BadgeProps,
} from 'core/components/Badge';

type Props = {
  tooltip?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
} & PropsWithChildren & BadgeProps;

export default function IconBadgeButton({
  tooltip,
  onClick,
  children,
  classes,
  ...props
}: Props) {
  return (
    <ToolTip title={tooltip}>
      <MuiIconButton
        size="small"
        onClick={onClick}
      >
        <Badge
          classes={{
            ...classes,
            icon: clsx(classes?.icon, 'text-base'),
          }}
          {...props}
        >
          {children}
        </Badge>
      </MuiIconButton>
    </ToolTip>
  );
}
